import { render } from "./HeaderPanel.vue?vue&type=template&id=4260f0c0&ts=true"
import script from "./HeaderPanel.vue?vue&type=script&lang=ts"
export * from "./HeaderPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/ecosystem/web-hrd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__